import React from "react";
import "./detailsTab.css";
import { Tab,Row,Col,Nav} from "react-bootstrap";
import MovieDetails from "../moredetails/moviedetail";
import RLandscapeSlider from "../landscapeSlider/Rlandscape";
import { useTranslation } from "react-i18next";

const MoviesTab = (props) =>
{

  const { t } = useTranslation(["translation"]);


return(<Tab.Container id={props.id} defaultActiveKey={props.active} >
<Row className="tabist">
  <Col sm={12}>
  <Nav className="justify-content-center">
    {props.type==="season"?(
         <Nav.Item>
             <Nav.Link  eventKey="episodes">{t("tab_Episode")}</Nav.Link>
        </Nav.Item>
     
     
    ):("")}
    <Nav.Item>
      <Nav.Link eventKey="6120bd274387ba2c049a917a">{t("tab_Related")}</Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link eventKey="more_details">{t("tab_Details")}</Nav.Link>
    </Nav.Item>
  
  </Nav>
  
  </Col>
  <Col sm={12}>
    <Tab.Content>
      {props.type==="season"?( <Tab.Pane eventKey="episodes">
          <Row style={{paddingTop:"12px"}}>
              <Col sm={12}>
               
             
              </Col>
           
          </Row>
          <Row>
              <Col sm={12}>
              
              </Col>
          </Row>
      
      </Tab.Pane>):("")}
      <Tab.Pane eventKey="6120bd274387ba2c049a917a">
     <RLandscapeSlider  recomm={props.recomm} recom={props.recomm} videoId={props.videoId} offset= {1} {...props}></RLandscapeSlider>
       
      </Tab.Pane>
      <Tab.Pane eventKey="more_details">
      <MovieDetails {...props}></MovieDetails>
      </Tab.Pane>
    </Tab.Content>
  </Col>
</Row>
</Tab.Container>);
}

export default MoviesTab;